import React from 'react'

export const exampleItem = (
  <div
    style={{ textAlign: 'center', backgroundColor: 'rgba(225, 225, 225, 0.6)', height: '35px', marginBottom: '6px' }}
  />
)

export const exampleStyles = {
  textAlign: 'center',
  backgroundColor: 'rgba(225, 225, 225, 0.6)',
  height: '35px',
  marginBottom: '6px'
}
